import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';


@Component({
  selector: 'alm-slide-out-panel',
  styleUrls: ['./slide-out-panel.component.less'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translateX(0)'
      })),
      state('out', style({
        transform: 'translateX(100%)'
      })),
      transition('in => out', animate('300ms ease-in-out')),
      transition('out => in', animate('500ms ease-in-out'))
    ])
  ],
  template: `<div [@slideInOut]="panelState" class="detail-panel"><div class="col-md-12 col-sm-12 col-xs-12 mobile-bar"><div class="dropdown-kebab-pf detail-type-dropdown col-sm-8"><span class="wi-type-icon fa {{itemIcon}} fa-2x"></span> <span *ngIf="itemName" class="detail-id" id="wi-detail-id">{{itemName}}</span></div><div class="col-sm-4"><span class="pull-right"><span class="pficon-close detail-close" (click)="closeDetails()"></span></span></div></div><div class="clear-float"></div><ng-content></ng-content></div>`
})

export class SlideOutPanelComponent implements OnInit, AfterViewInit {
  @Input() panelState: string;
  @Input() itemName: string;
  @Input() itemIcon: string;
  @Output() panelStateChange = new EventEmitter<string>();

  constructor(
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  closeDetails(): void {
    this.panelState = 'out';
    this.panelStateChange.emit(this.panelState);
  }
}
